/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PropTypes = require("prop-types");
var React = require("react");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Spinner.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var propTypes = {
    className: PropTypes.string
};
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-spinner");
exports.Spinner = function Spinner(_a) {
    var className = _a.className;
    var cssClassNames = [moduleClassName(), className];
    return (React.createElement("div", { className: classnames(cssClassNames) },
        React.createElement("svg", { className: moduleClassName("svg"), viewBox: "25 25 50 50" },
            React.createElement("circle", { className: moduleClassName("path"), cx: "50", cy: "50", r: "20", fill: "none", strokeWidth: "1", strokeMiterlimit: "10" }))));
};
exports.Spinner.propTypes = propTypes;